import { Component } from "vue";

export class MenuEntry {
  private _subItems?: Array<MenuEntry>;

  component?: Component;
  icon?: Component;
  text: string;
  key: string;
  callback?: (event?: MouseEvent) => void;
  hasSeparator: boolean;
  disabled: boolean = false;

  constructor(
    text: string,
    key?: string,
    callback?: (event?: MouseEvent) => void,
    icon?: Component,
    hasSeparator?: boolean
  ) {
    this.text = text;
    this.key = key ?? text;
    this.callback = callback;
    this.icon = icon;
    this.hasSeparator = hasSeparator ?? false;
  }

  addSubItem(item: MenuEntry) {
    this._subItems = this._subItems || new Array<MenuEntry>();
    this._subItems.push(item);
  }

  get subItems() {
    return this._subItems;
  }

  static getMenuEntries(
    items: any[],
    itemTextProperty?: string,
    getText?: (item: any) => string,
    itemKeyProperty?: string,
    getKey?: (item: any) => string,
    itemDisabledProperty?: string,
    checkDisabled?: (item: any) => boolean
  ) {
    const entries = new Array<MenuEntry>();
    items.forEach((item) => {
      const entry = new MenuEntry(
        this.calculateText(item, itemTextProperty, getText),
        this.calculateKey(item, itemKeyProperty, getKey)
      );
      entry.disabled = this.calculateDisabled(item, itemDisabledProperty, checkDisabled);
      entry.icon = item.icon;
      entries.push(entry);
    });
    return entries;
  }

  static calculateDisabled(
    item?: any,
    itemDisabledProperty?: string,
    checkDisabled?: (item: any) => boolean
  ) {
    if (checkDisabled) {
      const disabled = checkDisabled(item);
      if (typeof disabled === "boolean") {
        return disabled;
      } else {
        console.warn("Custom disabled check function is invalid.");
      }
    } else if (
      typeof item === "object" &&
      item !== null &&
      itemDisabledProperty &&
      itemDisabledProperty in item &&
      typeof item[itemDisabledProperty] === "boolean"
    ) {
      return item[itemDisabledProperty];
    }
    return false;
  }

  static calculateKey(
    item?: any,
    itemKeyProperty?: string,
    getKey?: (item: any) => string
  ): any {
    if (getKey) {
      return getKey(item);
    }
    if (
      typeof item === "object" &&
      item !== null &&
      itemKeyProperty &&
      itemKeyProperty in item
    ) {
      return item[itemKeyProperty]?.toString() ?? "";
    }
    return undefined;
  }

  static calculateText(
    item?: any,
    itemTextProperty?: string,
    getText?: (item: any) => string
  ): string {
    if (getText) {
      return getText(item);
    }
    if (
      typeof item === "object" &&
      item !== null &&
      itemTextProperty &&
      itemTextProperty in item
    ) {
      return item[itemTextProperty]?.toString() ?? "";
    }
    return item?.toString() ?? "";
  }
}
